import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2 } from 'lucide-react';
import { useAdminAuth } from '../contexts/AdminAuthContext';

const Login = () => {
  const { user, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Mark this entire admin section as no-index
  useEffect(() => {
    document.title = 'O2 Control Panel';
    const m = document.createElement('meta');
    m.name = 'robots';
    m.content = 'noindex, nofollow';
    document.head.appendChild(m);
    return () => { try { document.head.removeChild(m); } catch {} };
  }, []);

  useEffect(() => {
    if (user) navigate('/o2-control-panel/dashboard', { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate('/o2-control-panel/dashboard', { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Login failed. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <form onSubmit={submit} className="admin-login-card" data-testid="admin-login-form">
        <div className="admin-login-icon"><Lock size={28} /></div>
        <h1>O2 Control Panel</h1>
        <p className="admin-login-sub">Authorized personnel only</p>
        <input
          type="email"
          placeholder="Email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="admin-login-email"
        />
        <input
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          data-testid="admin-login-password"
        />
        {error && <div className="admin-error" data-testid="admin-login-error">{error}</div>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit">
          {loading ? <Loader2 className="spin" size={18} /> : 'Sign In'}
        </button>
      </form>
    </div>
  );
};

export default Login;
